module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAQCAYAAAArij59AAAACXBIWXMAAAsSAAALEgHS3X78AAAAiUlEQVQoz4WRwQ2DMAxFX6zeUbnBFGEDVugGZRQmgRG6QdkgnYIjEhOkF4PUyjG+fb+vb8cJOWe8ulnNuu2ewASM4T+hbrsIJJUPMeCictjW9BIDVgpnAPEgQLg3sQiPhCI8R3glQA/swKTv/zVsa/p4JgHwTOcOJZN16h54m6fWpAUYVMZw9d1fk3dCOyinlXsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/offcn-teacher-lottery/img/back.png
// module id = BgfN
// module chunks = 1